import { MapPin, ArrowUpRight, Heart } from "lucide-react";
import { useLang } from "@/i18n";
import { BOOKING_URL } from "@/photos";
import { FadeUp } from "./Reveal";

export default function Footer() {
  const { t } = useLang();

  return (
    <footer className="relative overflow-hidden bg-stone-950 py-20 text-white">
      <div className="animate-drift absolute -left-24 top-0 h-72 w-72 rounded-full bg-teal-600/15 blur-3xl" />
      <div className="animate-drift-slow absolute -right-16 bottom-0 h-72 w-72 rounded-full bg-pink-600/15 blur-3xl" />

      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <FadeUp className="flex flex-col items-start justify-between gap-10 md:flex-row md:items-end">
          <div>
            <div className="w-fit rounded-2xl bg-white px-4 py-3 shadow-lg">
              <img src="/logo.png" alt="Welcome Love House Roma" className="h-16 w-auto" />
            </div>
            <p className="font-display mt-6 max-w-md text-2xl italic text-stone-300 sm:text-3xl">
              {t.footer.claim}
            </p>
          </div>

          <a
            href={BOOKING_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-booking-cta"
            className="group inline-flex items-center gap-3 rounded-full bg-pink-600 px-8 py-4 text-base font-bold text-white shadow-xl shadow-pink-600/30 transition-[transform,background-color] duration-300 hover:scale-105 hover:bg-pink-700"
          >
            {t.footer.cta}
            <ArrowUpRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
          </a>
        </FadeUp>

        <div className="mt-14 flex flex-col gap-6 border-t border-white/10 pt-8 text-sm text-stone-400 md:flex-row md:items-center md:justify-between" data-testid="footer-contact-info">
          <div className="flex flex-col gap-1">
            <span className="flex items-center gap-2 font-medium text-stone-200">
              <MapPin className="h-4 w-4 text-pink-500" />
              {t.footer.address}
            </span>
            <span className="pl-6 text-xs uppercase tracking-[0.25em] text-stone-500">{t.footer.zone}</span>
          </div>
          <p className="flex items-center gap-1.5 text-xs text-stone-500">
            © 2026 Welcome Love House Roma · {t.footer.rights}
            <Heart className="h-3 w-3 fill-pink-600 text-pink-600" />
          </p>
        </div>
      </div>
    </footer>
  );
}
